module.exports = __webpack_public_path__ + "img/guarantee_01region@2x.41a9feeb.png";